import { Stack } from "@mui/material";
import { DownRightArrowIcon } from "Assets/icons";
import { SmText, XsTextMd } from "Components";
import { COLORS } from "constants/layout";
import { useLoading } from "providers/loading";
import { memo, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { apiGenerateInquiry } from "services/api/inquiry";

type Props = {
  onChangeContent: (content: string) => void;
  genNumber?: number;
};

const ContentGenerationChip = ({ onChangeContent, genNumber = 5 }: Props) => {
  const t = useIntl();
  const [randomNumbers, setRandomNumbers] = useState<number[]>([]);
  const { setLoading } = useLoading();

  const generateRandomNumbers = () => {
    const numbers: Set<number> = new Set();
    while (numbers.size < genNumber) {
      const randomNumber = Math.floor(Math.random() * 17) + 1;
      numbers.add(randomNumber);
    }
    setRandomNumbers([...numbers]);
  };

  const onClickText = async (number?: number) => {
    setLoading(true);
    const currentText = t.formatMessage({
      id: `inquiry_content_gen_${number}`,
    });
    const data = await apiGenerateInquiry(currentText);
    onChangeContent(data.data?.message?.data);
    setLoading(false);
  };

  useEffect(() => {
    generateRandomNumbers();
  }, [genNumber]);

  return (
    <Stack width="100%" spacing={1} mt={2}>
      <SmText color={COLORS.gray[500]}>
        {t.formatMessage({ id: "inquiry_content_gen_title" })}
      </SmText>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {randomNumbers.map((idx) => (
          <XsTextMd
            key={idx}
            color={COLORS.gray[700]}
            px={2}
            py="3px"
            bgcolor={COLORS.gray[100]}
            borderRadius={3}
            minHeight={24}
            display="flex"
            alignItems="center"
            gap={0.5}
            sx={{ cursor: "pointer" }}
            onClick={() => onClickText(idx)}
          >
            <DownRightArrowIcon />
            {t.formatMessage({ id: `inquiry_content_gen_${idx}` })}
          </XsTextMd>
        ))}
      </Stack>
    </Stack>
  );
};

export default memo(ContentGenerationChip);
